// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","secondary":"#33C370","wrapper":"_2fDJYUeZqZSRE5lQ_jykfr","preloader":"_38C79vEk8E7vHxALzU9ruv","hint":"_1W9Wmbci5sh-lhjXFOF9tF","list-wrapper":"_1hylm_ib-KqE9oUZ5b0UVJ","buttonsWrapper":"_1IsHs6H2KT2E8jbgGAHFrO","link":"_24LzntBsU3y3B_Balm6J_-","button-icon":"_39z85xmUnpL3PSZAw7BVIB","container":"_3Wi6JRbF8T3IDor41LnOVE","calendar-wrapper":"_3dnlLTpYpRyx4tGoTvgjgt","skills-container":"_3lEDfmYLxj43xmHeokIoWw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/Skills.mod.css
// module id = 1786
// module chunks = 0